import { useEffect, useState } from 'react'

/**
 * Följer uppkopplingen över tid.
 *
 * `navigator.onLine` lästes tidigare rakt av under rendering, vilket gjorde
 * den till en ögonblicksbild: öppnade man ett erbjudande med täckning och
 * tappade den i kön kom varningen aldrig fram, och kom täckningen tillbaka
 * låg den kvar. Med lyssnarna blir det ett tillstånd i stället för en gissning.
 *
 * Värt att veta: `onLine` ljuger gärna åt andra hållet – ansluten till ett
 * wifi utan internet räknas som online. Därför är den bra på att säga "du är
 * offline" men inte på att lova att något kommer fungera.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine)

  useEffect(() => {
    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)

    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return online
}
